import {
  AfterViewInit,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NbDialogRef } from "@nebular/theme";
import { Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";
import { User } from "../../../@core/data/users";
import { UserService } from "../../../@core/services/user.service";
import { convertTimestamp } from "../../../@core/utils/convertTimestamps.service";
import { Purchase } from "../../../models/purchase.model";
import Shop from "../../../models/shop.model";

import { PurchaseService } from "../../../services/purchase.service";

@Component({
  selector: "ngx-layout-purchase-a4-ppd",
  templateUrl: "layout-purchase-a4-ppd.component.html",
  styleUrls: ["layout-purchase-a4-ppd.component.scss"],
})
export class LayoutPurchaseA4PPDComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  private destroy$: Subject<void> = new Subject<void>();
  @Input() shopId?: string;
  @Input() uid?: string;
  @Input() purchase?: Purchase;
  @Input() shop?: Shop;
  @Input() isRefLanguage?: boolean = false;

  loading = false;
  printing = false;
  displayName = "";
  currentDate: Date = new Date();

  constructor(
    private userService: UserService,
    private purchaseService: PurchaseService
  ) {}

  ngOnInit() {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;
          this.shopId = user.shopId ? user.shopId : user.uid;
          this.displayName = user.displayName ? user.displayName : user.email;
        } else {
          this.uid = "anonymous";
          this.shopId = "anonymous";
          this.displayName = "";
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngAfterViewInit() {
    // setTimeout(() => {
    //   if (this.rePrint) {
    //     this.print();
    //   } else {
    //     this.printing = false;
    //   }
    // });
  }

  print() {
    this.printing = true;
  }
}
